import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { CanColor, mixinColor } from '@angular/material/core';
import { Constructor } from '@angular/material/core/common-behaviors/constructor';
import { MatSelectionListChange } from '@angular/material/list';

import { OptionBundle } from '@mtna/rds-packaging-ui';

export class RdsBundleSelectionEvent {
  /**
   * @param selected Whether the bundle is selected
   * @param bundle The bundle
   */
  constructor(public selected: boolean, public bundle: OptionBundle) {}
}

export class RdsBundleSelectionBase {
  constructor(public _elementRef: ElementRef) {}
}

export const _RdsBundleSelectionMixinBase: Constructor<CanColor> & typeof RdsBundleSelectionBase = mixinColor(
  RdsBundleSelectionBase,
  'primary'
);

/**
 * A list of packaging format bundles.
 * Each list item can be clicked in order to build up a list of desired bundles.
 *
 * @author Will Davis <will.davis@mtna.us>
 */
@Component({
  selector: 'rds-bundle-selection-list',
  templateUrl: './bundle-selection-list.component.html',
  styleUrls: ['./bundle-selection-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class RdsBundleSelectionListComponent extends _RdsBundleSelectionMixinBase implements CanColor {
  /** Bundles to display in the list */
  @Input() bundles: Array<OptionBundle>;
  /** Theme color, defaults to primary */
  @Input() color: 'primary' | 'accent';
  /** Selected bundles */
  @Input() selected: Array<OptionBundle> = [];
  /** Emitted when a bundle is selected or unselected */
  @Output() selectionChange = new EventEmitter<RdsBundleSelectionEvent>();

  constructor(_elementRef: ElementRef) {
    super(_elementRef);
  }

  handleSelectionChange(event: MatSelectionListChange) {
    this.selectionChange.emit(new RdsBundleSelectionEvent(event.option.selected, event.option.value));
  }

  /** Workaround since clicking a chip doesn't fire selection change in the mat-selection-list */
  _handleChipClick(bundle: OptionBundle) {
    const selected = this.selected.some(b => b.id === bundle.id);
    this.selectionChange.emit(new RdsBundleSelectionEvent(!selected, bundle));
  }

  _compareWithBundles(o1: OptionBundle, o2: OptionBundle) {
    if (!o1 || !o2) {
      return false;
    }
    return o1.id === o2.id;
  }
}
